// extracted by mini-css-extract-plugin
export default {"fr-view":"InputError_fr-view__EvtsC","container":"InputError_container__jBSN8"};